// Pipeline stages, in board order. Must match CRM_STAGES in server/src/routes/crm.js.
export const STAGES = [
  { key: 'new', label: 'New', dot: 'bg-gray-400' },
  { key: 'prospecting', label: 'Prospecting', dot: 'bg-blue-500' },
  { key: 'meeting', label: 'Meeting', dot: 'bg-indigo-500' },
  { key: 'proposal', label: 'Proposal', dot: 'bg-amber-500' },
  { key: 'won', label: 'Won', dot: 'bg-green-500' },
  { key: 'lost', label: 'Lost', dot: 'bg-red-400' },
];

export const STAGE_KEYS = STAGES.map((s) => s.key);
